import { handleActions, createAction } from "redux-actions";
import _uniq from "lodash/uniq";
//
import { createPromiseActionTypes } from "../utils/redux";
import Api from "../services/Api";

// ----------------------------------------------------------------------------------------------------------------------------
//  Actions
// ----------------------------------------------------------------------------------------------------------------------------
const IMAGE_REPORT = createPromiseActionTypes("flags/IMAGE_REPORT");
const REVIEW_REPORT = createPromiseActionTypes("flags/REVIEW_REPORT");
//
export const reportImageAction = createAction(IMAGE_REPORT.TYPE, (id) =>
  Api.reportImage(id)
);
export const reportReviewAction = createAction(REVIEW_REPORT.TYPE, (id) =>
  Api.reportReview(id)
);

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const initialState = {
  images: [],
  reviews: [],
};

export default handleActions(
  {
    [IMAGE_REPORT.FULFILLED]: handleReportImage,
    [REVIEW_REPORT.FULFILLED]: handleReportReview,
  },
  initialState
);

// ----------------------------------------------------------------------------------------------------------------------------
//  Action Reducers
// ----------------------------------------------------------------------------------------------------------------------------
function handleReportImage(state, action) {
  const { images } = state;

  return {
    ...state,
    images: _uniq([...images, action.payload]),
  };
}

function handleReportReview(state, action) {
  const { reviews } = state;

  return {
    ...state,
    reviews: _uniq([...reviews, action.payload]),
  };
}
